<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sMuqLe/tc-custom/cover.jpeg?1663929223077?1704424517078" alt="This image is the cover for the book The Night Of The Long Knives and two more stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Night Of The Long Knives and two more stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a great collection of action short stories by Fritz Leiber from "The Golden Age of Science Fiction". Featured here: "The Night Of The Long Knives", "A Pail Of Air", and "Friends and Enemies".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fritz Leiber
      </h2>
      
      <p class="authorDescription body article">Fritz Reuter Leiber Jr. (December 24, 1910 – September 5, 1992) was an American writer of fantasy, horror, and science fiction. He was also a poet, actor in theater and films, playwright, and chess expert. With writers such as Robert E. Howard and Michael Moorcock, Leiber is one of the fathers of sword and sorcery and coined the term.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f41b490